import React from 'react';
import { Button, Radio } from 'antd';
import { GenericTextArea } from '../../GenericTextArea/GenericTextArea';
import { t } from '../../../i18n/i18n';
import EvaluationPreview from '../../EvaluationPreview/EvaluationPreview';
import SafeContainer from '../../SafeContainer/SafeContainer';
import { getLocalStorageWorkspace } from '../../../utils/workspaceUtils';
import CountryFlag from '../../CountryFlag/CountryFlag';

export const TestGroupAssignment = ({
  handleSetAssignment,
  step,
  readOnly = false,
  languagesAvailable = [],
  languageToTranslate,
  languageList,
  languageSet,
  handleChangeLanguage,
}) => (
  <>
    {languagesAvailable && (
      <div className="row row-flex p-2 justify-content-end w-100">
        <Radio.Group
          value={languageSet}
          onChange={(e) => {
            handleChangeLanguage(e.target.value);
          }}
        >
          {languagesAvailable?.filter(Boolean)?.map((lang) => (
            <Radio.Button value={lang}>
              <CountryFlag
                countryIso={languageList?.find((y) => y.value === lang)?.iso}
                size="sm"
              />
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>
    )}
    <div className="d-flex flex-column flex-lg-row">
      <div className="mr-1 flex-column justify-content-between w-60">
        <p className=" font-weight-600 text-base mb-0">
          {languageToTranslate
            ? `${t('Estas editanto la consigna para el lenguaje: ')} ${t(
                languageList?.find((y) => y.value === languageToTranslate)?.label
              )}`
            : `${t('CREATE_TESTGROUP_TITLE_EDIT_ASSIGNMENT')}`}
        </p>
        <div className="d-flex flex-column justify-content-between">
          <GenericTextArea
            placeholder={t('CREATE_TESTGROUP_ASSIGNMENT_PLACEHOLDER')}
            onChange={(e) => {
              const normalizedValue = e === '<p><br></p>' ? '' : e;
              handleSetAssignment('subtitle', languageToTranslate, normalizedValue);
            }}
            richTextClassName="h-75 mb-2 pb-5"
            value={step.subtitle[languageToTranslate]}
            maxLength={5000}
            richText
            fontsType={['bold', 'italic', 'underline']}
            link={['link']}
          />
        </div>
        <div className="d-flex align-content-center">
          <Button
            type="button"
            disabled={step.subtitle[languageToTranslate]?.trim() === '' || readOnly}
            className={step.subtitle[languageToTranslate] === '' ? 'd-none' : 'px-3'}
            onClick={() => handleSetAssignment('subtitle', languageToTranslate, '')}
          >
            <span className="px-3 py-1 text-button-left-modal  d-flex justify-content-center align-items-center">
              {t('RESET_TESTGROUP_ASSIGNMENT')}
            </span>
          </Button>
        </div>
      </div>
      <div className="d-flex flex-column w-50" disabled={readOnly}>
        <p className=" font-weight-600 text-blue-principal text-base mb-0">{`${t('PREVIEW')}:`}</p>
        <EvaluationPreview
          className="mt-1"
          key={`start-assigment-${step.subtitle?.[languageSet]?.length}-${step.subtitle?.[
            languageSet
          ]?.codePointAt()}`}
        >
          <div className="d-flex flex-column justify-content-between align-items-left bg-white">
            <SafeContainer
              content={
                (step.subtitle?.[languageSet] ?? '')?.trim() !== ''
                  ? step.subtitle?.[languageSet] ?? ''
                  : t('CREATE_TESTGROUP_ASSIGNMENT_DEFAULT').replace(
                      'company',
                      getLocalStorageWorkspace()?.companyName
                    )
              }
              readOnly
              theme="bubble"
            />
          </div>
        </EvaluationPreview>
      </div>
    </div>
  </>
);
